(function () {
    'use strict';

    var $ = window.jQuery;

    function MoreMenu() {
        var $self = this;
        $(document).on('click', '[data-toggle="more-menu"]', function (e) {
            e.preventDefault();
            console.log(123);

            var $el = $(this),
                $parent = $el.parent();

            $parent.toggleClass('show-more-menu');
            return false;
        });
    }

    window.MoreMenu = MoreMenu;
}())
;